import { ProductCheckpointListDTO } from '../product-checkpoint/product-checkpoint-list.dto';
import { ProductGroupListDTO } from '../product-group/product-group-list.dto';
import { ProductVersionListDTO } from '../product-version/product-version-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';
import { ManuscriptListDTO } from '../manuscript/manuscript-list.dto';

export class ProductDTO extends TeamAccessDTO {

    itemNumber: string;

    name: string;

    description: string;

    versions: Array<ProductVersionListDTO>;

    checkpoints: Array<ProductCheckpointListDTO>;

    groups: Array<ProductGroupListDTO>;

    manuscripts: Array<ManuscriptListDTO>;

}
